import { createWebHashHistory, createRouter } from "vue-router";

export default createRouter({
    history: createWebHashHistory(),
    routes: [{
        path: "/",
        redirect: "/login",
        component: () =>
            import ("@/view/layout/LayoutMain.vue"),
        children: [{
            path: "/login/:sistema",
            name: "login",
            component: () =>
                import ("@/view/pages/LoginScreen.vue")
        }, {
            path: "/login/register/:token",
            name: "login-register",
            component: () =>
                import ("@/view/pages/RegisterScreen.vue")
        }, {
            path: "/login/forgetpass/:sistema",
            name: "forget-pass",
            component: () =>
                import ("@/view/pages/ForgetPassword.vue")
        }, {
            path: "/login/saibamais/:sistema",
            name: "saiba-mais",
            component: () =>
                import ("@/view/pages/SaibaMaisChat.vue")
        }]
    }]
});